import React from 'react';
import PageHeader from '../components/PageHeader';

const Notifications = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Notifications"
        description="Manage your notifications"
        breadcrumbs={['Home', 'Notifications']}
      />

      <div className="bg-white rounded-xl border border-gray-100 p-6">
        <div className="space-y-4">
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" defaultChecked className="w-4 h-4 accent-amber-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">New Orders</p>
              <p className="text-xs text-gray-600">Get notified when a new order is placed</p>
            </div>
          </label>

          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" defaultChecked className="w-4 h-4 accent-amber-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">Low Stock Alerts</p>
              <p className="text-xs text-gray-600">Get notified when product stock is low</p>
            </div>
          </label>

          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" defaultChecked className="w-4 h-4 accent-amber-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">Customer Reviews</p>
              <p className="text-xs text-gray-600">Get notified when customers leave reviews</p>
            </div>
          </label>

          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" className="w-4 h-4 accent-amber-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">Payment Updates</p>
              <p className="text-xs text-gray-600">Get notified about payment status changes</p>
            </div>
          </label>

          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" className="w-4 h-4 accent-amber-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">System Updates</p>
              <p className="text-xs text-gray-600">Get notified about system maintenance</p>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
